export default __webpack_public_path__ + "static/media/alliedHangers3.9353ead2.jpg";